module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("autoprefix 推荐配置")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("vue")]), _vm._v("官方模板的设置是"), _c('code', [_vm._v("last 2 versions")]), _vm._v("，可能会导致你在某些"), _c('code', [_vm._v("Android")]), _vm._v("机子上出现问题。")]), _vm._v(" "), _c('p', [_vm._v("如果你使用 "), _c('code', [_vm._v("last 7 versions")]), _vm._v(" 会生成不必要的"), _c('code', [_vm._v("-ms")]), _vm._v("前缀代码.")]), _vm._v(" "), _c('p', [_vm._v("因此建议同"), _c('code', [_vm._v("WeUI")]), _vm._v("一样，使用配置 "), _c('code', [_vm._v("['iOS >= 7', 'Android >= 4.1']")])]), _vm._v(" "), _c('h2', [_vm._v("直接在 vux-loader 里配置")]), _vm._v(" "), _c('p', [_vm._v("如果你没有在 postcss 里配置，你可以直接配置 vux-loader 的 "), _c('code', [_vm._v("duplicate-style")]), _vm._v(" 插件：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'duplicate-style'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("options")]), _vm._v(": {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("cssProcessorOptions")]), _vm._v(" : {\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("safe")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("true")]), _vm._v(",\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("zindex")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v(",\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("autoprefixer")]), _vm._v(": {\n        "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("add")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("true")]), _vm._v(",\n        "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"browsers\"")]), _vm._v(": [\n          "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"iOS >= 7\"")]), _vm._v(",\n          "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"Android >= 4.1\"")]), _vm._v("\n        ]\n      }\n    }\n  }\n}\n")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-56593d7b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-56593d7b"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/vue-loader-autoprefix-161.vue
// module id = 2252
// module chunks = 215